import axios from 'axios';
import {BACKEND_BASEURL} from "@/config/config";

/**
 * Admin-only MPM state fixes (backend /mpmAdmin routes). One entry per
 * operation: which membership states it may start from (mirrors the backend
 * guards) and which input fields the dialog has to collect.
 */
export const MPM_ADMIN_ACTIONS = {
  revertOnlinePhase: {
    allowedStatuses: ['STARTED', 'DECLINED', 'WAITING_FOR_USER', 'ACCEPTED', 'ABORTED', 'ACTIVE', 'ENDING', 'ENDED'],
    fields: ['note'],
  },
  abortOnboarding: {
    allowedStatuses: ['STARTED', 'WAITING_FOR_USER', 'ACCEPTED'],
    fields: ['note'],
  },
  forceGoLive: {
    allowedStatuses: ['STARTED', 'ACCEPTED'],
    fields: ['dateStart', 'consentId', 'note'],
  },
  endMembership: {
    allowedStatuses: ['ACTIVE', 'ENDING'],
    fields: ['dateEnd', 'reasonEnded', 'revocationStatus', 'note'],
  },
};

export const REASON_ENDED_VALUES = ['USER_REJECTED', 'IMPLICIT_ENDED', 'COMMUNITY_ENDED'];
export const REVOCATION_STATUS_VALUES = ['ONGOING', 'FAILED', 'SUCCESS'];

export function isActionAllowed(action, membershipStatus) {
  return MPM_ADMIN_ACTIONS[action]?.allowedStatuses.includes(membershipStatus) ?? false;
}

/**
 * Builds the request body for an action from the dialog inputs, dropping
 * empty optional fields.
 */
export function buildStateFixBody(action, inputs) {
  const fields = MPM_ADMIN_ACTIONS[action]?.fields ?? [];
  const body = {};
  for (const field of fields) {
    const value = inputs[field];
    if (value !== undefined && value !== null && value !== '')
      body[field] = value;
  }
  return body;
}

export async function runMpmStateFix(action, mpmObjectId, inputs) {
  if (!MPM_ADMIN_ACTIONS[action])
    throw new Error(`unknown mpm admin action: ${action}`);

  const response = await axios.post(
    `${BACKEND_BASEURL}mpmAdmin/${mpmObjectId}/${action}`,
    buildStateFixBody(action, inputs),
  );
  return response.data;
}
